<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>流程模板</el-breadcrumb-item>
      <el-breadcrumb-item>模板管理</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="panel">
      <div class="pad-btm form-inline">
        <button
          class="btn btn-sm btn-labeled btn-rounded btn-purple"
          data-toggle="modal"
          data-target="#FlowTemplateEditor"
        >
          <i class="btn-label ion-plus-circled"></i>新建流程
        </button>
      </div>
      <div class="table-responsive">
        <table
          v-if="templates.length > 0"
          class="table table-striped table-vcenter"
        >
          <thead>
            <tr>
              <th>模板名称</th>
              <th>模板说明</th>
              <th class="text-center">步骤</th>
              <th v-code="41102" class="text-center">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(template, index) in templates" v-bind:key="template.id">
              <td>{{ template.name }}</td>
              <td>{{ template.desc }}</td>
              <td class="text-center">
                <router-link
                  class="text-info"
                  :to="'nodedit?flowId=' + template.id"
                  >编辑步骤[{{ template.nodes.length }}个工序]</router-link
                >
              </td>
              <td v-code="41102" class="text-center actions">
                <button
                  class="btn btn-sm btn-labeled btn-rounded btn-default"
                  @click="edit(template, index)"
                >
                  <i class="btn-label ion-edit"></i> 编辑
                </button>
                <button
                  @click="del(template, index)"
                  class="btn btn-sm btn-labeled btn-rounded btn-warning"
                >
                  <i class="btn-label ion-close-circled"></i> 删除
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else>还未创建模板。</div>
      </div>
    </div>
    <flow-template-editor
      :model="editTemplate"
      v-on:created="flowTemplateCreated"
      v-on:updated="flowTemplateUpdated"
    ></flow-template-editor>
  </div>
</template>

<script>
import { flowTemplates, deleteFlowTemplate } from '@/service/getData'
import flowTemplateEditor from '@/views/produce/flow/flow_template_editor'
export default {
  components: {
    flowTemplateEditor,
  },
  data() {
    return {
      templates: [],
      editTemplate: null,
      editIndex: -1,
    }
  },
  created() {
    this.initData()
  },
  methods: {
    async initData() {
      let res = await flowTemplates()
      this.templates = res.data.list
    },
    edit(tmp, index) {
      this.editTemplate = tmp
      this.editIndex = index
      $('#FlowTemplateEditor').modal('show')
    },
    del(tmp, index) {
      let that = this
      this.$confirm('确认删除模板' + tmp.name + '？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let data = {
            flowId: tmp.id,
          }
          deleteFlowTemplate(data).then((res) => {
            if (res.code == 0) {
              that.$message({
                showClose: false,
                duration: 1000,
                message: '删除成功',
                type: 'success',
              })
              that.templates.splice(index, 1)
            }
          })
        })
        .catch(() => {})
    },
    flowTemplateUpdated(tmp) {
      this.$message({
        showClose: false,
        duration: 1000,
        message: '更新成功！',
        type: 'success',
      })
      tmp.nodes = this.templates[this.editIndex].nodes
      this.templates[this.editIndex] = tmp
      this.editTemplate = null
      this.editIndex = -1
    },
    flowTemplateCreated(tmp) {
      this.$message({
        showClose: false,
        duration: 1000,
        message: '流程模板创建成功！',
        type: 'success',
      })
      tmp.nodes = []
      this.templates.unshift(tmp)
    },
  },
}
</script>

<style scoped>
.actions button {
  display: inline-block;
  margin-right: 1em;
  cursor: pointer;
}
</style>